<template>
  <div :class="$style['pt-lab-order-form']" v-loading="loading">
    <pt-sub-title title="委托方信息" :showCollapse="true" :open="open">
      <div slot="collapse-content">
        <!-- 系统自动生成 -->
        <!-- <pt-form-item label="委托单编号：" :labelWidth="labelWidth">
          <el-input placeholder="请填写委托单编号" v-model="form.billCode" ></el-input>
        </pt-form-item> -->
        <pt-form-item label="委托方单位名称：" :labelWidth="labelWidth" :required="true">
          <el-input placeholder="请填写委托方单位名称" v-model="form.organization.base.name" data-vv-as="委托方单位名称" v-validate="'required'"></el-input>
          <wt-input v-model="form.organization.id" style="display:none" v-validate="form.organization.base.name? '':'required'" data-vv-as="委托方"></wt-input>
          <el-button plain type="primary" style="margin-left:10px" @click="selectClient">点击选择</el-button>
        </pt-form-item>
        <pt-form-item label="联系人：" :labelWidth="labelWidth" :required="true">
          <el-input placeholder="请填写联系人" v-model="form.organization.base.contact" data-vv-as="联系人" v-validate="'required'"></el-input>
        </pt-form-item>
        <pt-form-item label="手机号：" :labelWidth="labelWidth" :required="true">
          <el-input placeholder="请填写手机号" v-model="form.organization.base.mobile" data-vv-as="手机号" v-validate="'required'"></el-input>
        </pt-form-item>
        <pt-form-item label="身份证号：" :labelWidth="labelWidth">
          <el-input placeholder="请填写身份证号" v-model="form.organization.base.cardId" data-vv-as="身份证号" v-validate="'idCard'"></el-input>
        </pt-form-item>
        <pt-form-item label="邮箱：" :labelWidth="labelWidth">
          <el-input placeholder="请填写邮箱" v-model="form.organization.base.email"></el-input>
        </pt-form-item>
        <pt-form-item label="通讯地址：" :labelWidth="labelWidth" :required="true">
          <el-input placeholder="请填写通讯地址" v-model="form.organization.base.address.postAddress" data-vv-as="通讯地址" v-validate="'required'"></el-input>
        </pt-form-item>
        <pt-form-item label="社会统一信用代码：" :labelWidth="labelWidth" :required="true">
          <el-input name="base.secCode" data-vv-as="社会统一信用代码" v-validate="'required'" v-model="form.organization.base.secCode" placeholder="请填写社会统一信用代码"></el-input>
        </pt-form-item>
        <pt-form-item label="企业执照副本：" :labelWidth="labelWidth">
          <wt-upload-big-file v-model="form.organization.base.licenses" @getStatus="getStatus"></wt-upload-big-file>
        </pt-form-item>
        <pt-form-item label="开票类型：" :labelWidth="labelWidth" :required="true">
          <el-radio-group name="organization.invoice.type" data-vv-as="开票类型" v-validate="'required'" v-model="form.organization.invoice.type">
            <el-radio label="ORDINARY_VAT">增值税普通发票</el-radio>
            <el-radio label="SPECIAL_VAT">增值税专用发票</el-radio>
          </el-radio-group>
        </pt-form-item>
        <!-- <pt-form-item label="可开具发票类型：" :labelWidth="labelWidth" :required="true">
          <el-checkbox-group data-vv-as="开具发票类型" v-validate="'required'" v-model="form.organization.invoice.ableType">
            <el-checkbox label="ELECTRONIC_VAT">电子发票</el-checkbox>
            <el-checkbox label="PAPER_VAT">纸质发票</el-checkbox>
          </el-checkbox-group>
        </pt-form-item> -->
        <pt-form-item label="可开具发票内容：" :labelWidth="labelWidth" :required="true">
          <el-radio-group name="invoiceContent" data-vv-as="可开具发票内容" v-validate="'required'" v-model="form.invoiceContent">
            <el-radio label="测试费">测试费</el-radio>
            <el-radio label="技术服务费">技术服务费</el-radio>
          </el-radio-group>
          <!-- <el-input name="可开具发票内容" data-vv-as="可开具发票内容" v-validate="'required'" v-model="form.invoiceContent" placeholder="可开具发票内容"></el-input> -->
        </pt-form-item>
        <pt-form-item label="发票抬头：" :labelWidth="labelWidth" :required="true">
          <el-input data-vv-as="发票抬头" v-validate="'required'" v-model="form.organization.invoice.title" placeholder="请填写发票抬头"></el-input>
        </pt-form-item>
        <pt-form-item label="纳税人识别号：" :labelWidth="labelWidth" :required="true">
          <el-input data-vv-as="纳税人识别号" v-validate="'required'" v-model="form.organization.invoice.taxId" placeholder="请填写纳税人识别号"></el-input>
        </pt-form-item>
          <pt-form-item label="邮寄地址：" :labelWidth="labelWidth">
            <el-input data-vv-as="邮寄地址：" v-model="form.reportShippingAddress" placeholder="请填写邮寄地址"></el-input>
          </pt-form-item>
      </div>
    </pt-sub-title>

    <!-- <pt-sub-title title="样品信息" :showCollapse="true" :open="open">
      <div slot="collapse-content">
        <sampleTypeForm v-model="form.preOrderSummaryList"></sampleTypeForm>
      </div>
    </pt-sub-title> -->

    <pt-sub-title title="委托内容" :showCollapse="true" :open="open">
      <div slot="collapse-content">
        <pt-form-item label="委托单编号：" :labelWidth="labelWidth" v-if="showBillCode">
            <el-input placeholder="请填写委托单编号" v-model="form.billCode" ></el-input>
          </pt-form-item>
        <pt-form-item label="所属科室：" :labelWidth="labelWidth" :required="true">
          <wt-selector data-vv-as="所属科室" v-validate="'required'" v-model="form.departmentName" :options="departementList" :allowCreate="true" placeholder="请选择所属科室"></wt-selector>
        </pt-form-item>
				<pt-form-item label="是否显示全部样品名称：" :labelWidth="labelWidth" :required="true">
					<el-radio-group data-vv-as="是否显示全部样品名称" v-validate="'required'" v-model="form.isDisplayAll">
            <el-radio label="true">是</el-radio>
            <el-radio label="false">否</el-radio>
          </el-radio-group>
				</pt-form-item>
        <pt-form-item label="检测项目：" :labelWidth="labelWidth" :required="true">
          <el-button plain type="primary" @click="selectProduct">点击选择</el-button>

          <wt-input v-model="form.labExamItemIds" style="display:none" v-validate="'required'" data-vv-as="检测项目"></wt-input>

          <div :class="$style['package-table-div']" class="page-background" v-if="form.labExamItemList && form.labExamItemList.length">
            <table :class="$style['package-table']">
              <th>
              <!-- <td>检测项目编号</td> -->
              <td>检测项目名称</td>
              <td>检测依据</td>
              <!-- <td>交付形式</td> -->
              <td>检测周期</td>
              <td>是否有偏离</td>
              <td>偏离原因</td>
              <td>相关文献</td>
              <td>操作</td>
              </th>
              <tr v-for="(item,i) in form.labExamItemList" :key="i">
                <!-- <td>{{item.itemVersion}}</td> -->
                <td>{{item.itemName}}</td>
                <td>{{item.examBasis&&item.examBasis.name}}</td>
                <!-- <td>{{item.testCycle&&item.testCycle.replace(/[^0-9]/ig, '') + item.dayType&&getdayType(item.dayType)}}</td> -->
								<td>{{item.changeCycle}}</td>
                <td>{{item.deviate?'是':"否"}}</td>
                <td>{{item.deviateInfo}}</td>
                <td>
                  <wt-upload-file :action="uploadApi" :data="picture_params" :img-url="privateResourcesUrl" listType="text" v-model="item.attachments" :class="$style['dialog-upload']">
                  </wt-upload-file>
                </td>
                <td>
                  <el-button type="text" @click="deleteLabProduct(i)">移除</el-button>
                </td>
              </tr>
            </table>
          </div>
        </pt-form-item>
        <!-- <pt-form-item label="检测依据：" :labelWidth="labelWidth">
          <array-input v-model="form.examBasisList" placeholder="请选择检测依据"></array-input>
        </pt-form-item>
        <pt-form-item label="是否有偏离：" :labelWidth="labelWidth">
          <el-select v-model="form.deviate" placeholder="请选择是否有偏离">
            <el-option label="是" :value="true"></el-option>
            <el-option label="否" :value="false"></el-option>
          </el-select>
          <span style="display:inline-block;width:20px"></span>
          <el-input placeholder="请填写详细情况描述" v-model="form.deviateInfo"></el-input>
        </pt-form-item> -->
        <!-- <pt-form-item label="相关文献：" :labelWidth="labelWidth">
          <wt-upload-file :action="uploadApi" :data="picture_params" :img-url="privateResourcesUrl" listType="text" v-model="form.attachments" :class="$style['dialog-upload']">
            <el-button size="small" type="primary">点击上传</el-button>
          </wt-upload-file>
        </pt-form-item> -->
        <pt-form-item label="交付方式：" :labelWidth="labelWidth" :required="true">
          <wt-selector data-vv-as="交付方式" v-validate="'required'" v-model="form.deliveryType" :options="terrace" :multiple="true" placeholder="请选择交付方式"></wt-selector>
        </pt-form-item>
        <pt-form-item label="报告份数：" :labelWidth="labelWidth">
          <el-input placeholder="请填写报告份数" v-model="form.reportNum"></el-input>
        </pt-form-item>
        <pt-form-item label="开始日期：" :labelWidth="labelWidth">
          <el-date-picker v-model="form.startDate" value-format="timestamp" type="date" placeholder="选择日期"></el-date-picker>
        </pt-form-item>
        <pt-form-item label="交付日期：" :labelWidth="labelWidth">
          <el-date-picker v-model="form.deliveryDate" value-format="timestamp" type="date" placeholder="选择日期" data-vv-as="交付日期"></el-date-picker>
        </pt-form-item>
        <pt-form-item label="是否返还：" :labelWidth="labelWidth" :required="true">
            <el-radio-group v-model="form.back" placeholder="请选择是否返还" data-vv-as="是否返还" v-validate="'required'">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
        </pt-form-item>
        <pt-form-item label="是否加急：" :labelWidth="labelWidth">
            <el-radio-group v-model="form.urgent">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
        </pt-form-item>
        <pt-form-item label="加急费（元）：" :labelWidth="labelWidth">
          <el-input placeholder="请填写加急费用" v-model="form.urgentMoney"></el-input>
        </pt-form-item>
        <pt-form-item label="检测费（元）：" :labelWidth="labelWidth">
          <el-input placeholder="请填写检测费（元）" v-model="form.examAmount"></el-input>
        </pt-form-item>
        <pt-form-item label="是否盖章：" :labelWidth="labelWidth">
          <el-radio-group v-model="form.mandateStamped">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </pt-form-item>
          <pt-form-item label="显示生产单位：" :labelWidth="labelWidth">
            <el-radio-group v-model="form.showProductionOrg">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
          </pt-form-item>
        <pt-form-item label="备注：" :labelWidth="labelWidth">
          <el-input v-model="form.remarks" placeholder="请填写备注" type="textarea"></el-input>
          <el-tag v-for="key in remarksTags" :key="key" @click="addTagForRemark(key)">{{ key }}</el-tag>
        </pt-form-item>
         <pt-form-item label="财务备注：" :labelWidth="labelWidth">
            <el-input v-model="form.financialNote" placeholder="请填写财务备注" type="textarea"></el-input>
          </pt-form-item>
      </div>
    </pt-sub-title>
    <div class="button-div" v-if="!showSamples">
      <el-button type="primary" @click="createBill">保持并继续</el-button>
      <el-button type="primary" plain @click="cancel">取消</el-button>
    </div>

    <pt-sub-title title="添加样品" :showCollapse="true" v-if="showSamples">
      <div slot="collapse-content">
        <sampleTableForm ref="sampleTable" :billCode="form.billCode" v-model="form.orderList" :sampleDisabled="sampleDisabled" :labExamItemList="form.labExamItemList" :hasExamList="true"  :isEdit="isEdit"></sampleTableForm>
      </div>
    </pt-sub-title>
    <div class="button-div" v-if="showSamples">
      <el-button type="primary" @click="saveOrder">保存</el-button>
      <el-button type="primary" plain @click="cancel">取消</el-button>
      <el-button type="danger" v-if="isEdit && !isComplete" plain @click="closeBill">关闭委托单</el-button>
      <el-button type="danger" v-if="isEdit" plain @click="deleteBill">删除委托单</el-button>
    </div>

    <!-- 选择委托方 -->
    <select-client-dialog :dialogVisible="showClientDialog" @close="closeClientDialog" @selectData="getClient" :pageSize="5" :selectedKeys="form.organization.id" :data="agentData"></select-client-dialog>
    <!-- 选择检测项目 -->
    <select-lab-product :dialogVisible="showDialog" @close="closeDefaultDialog" @selectData="selectData" :pageSize="5" :selectedKeys="form.labExamItemList.map(e=>e.id) || []" :selectedRows="form.labExamItemList" :isDialog="true">
    </select-lab-product>
  </div>
</template>

<script>
// 组件class前缀
import organizationSelector from 'cps/selector/organization-selector.vue'
import wtUploadBigFile from 'cps/common/wt-upload-big-file'
import sampleTypeForm from './sample-type-form.vue'
import sampleTableForm from './sample-table-form.vue'
// import ptAddressSelect from 'cps/base/pt-address-select/withData'
import selectClientDialog from './select-client-dialog.vue'
import selectLabProduct from './select-lab-product.vue'
// import ptProvinceSelect from 'cps/base/pt-province-select'
import arrayInput from 'cps/common/array-input'
import formMixins from 'mixins/form'
import { isRequired } from './form-required-option'
import {
  terrace,
  departementList
} from 'json/lab-order'
import {
  getdayType
} from 'enumeration/lab-order.js'

const prefixCls = 'pt-lab-order-form'
export default {
  name: 'pt-lab-order-form',
  mixins: [formMixins],
  computed: {
    classes () {
      return `${prefixCls}`
    },
    showBillCode () {
      return this.form.id&& this.form.billCode
    },

    isComplete () {
      return this.value && this.value?.nextBillAction === 'NONE'
    }
  },
  props: {
    value: {
      type: Object,
      default: () => { }
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  components: {
    // ptAddressSelect,
    organizationSelector,
    wtUploadBigFile,
    sampleTableForm,
    arrayInput,
    selectClientDialog,
    selectLabProduct,
    sampleTypeForm
  },
  data () {
    return {
      terrace,
      departementList,
      labelWidth: '170px',
      loading: false,
      form: this.value.id ? this.value : {
        deliveryType: ['PAPER'], // 交付方式
        examBasisList: [{ value: '' }], // 检测依据
        labExamItemList: [], // 检测项目
        organization: { // 组织
          base: {
            qualifications: [],
            contracts: [],
            licenses: [],
            address: {
              postAddress: ''
            }
          },
          // 发票
          invoice: {
            type: 'SPECIAL_VAT',
            ableType: []
          }
        },
        invoiceContent:'测试费',
        reportNum:1,
        orderList: [{ disabled: false }],
        preOrderSummaryList: [{ disabled: false }],
        urgent: false,
        mandateStamped: false,
        showProductionOrg: false
      },
      showDialog: false,
      showClientDialog: false,
      currentProduct: {},
      agentData: {},
      sampleTypes: [],
      showSamples: !!this.isEdit,
      open: true,
      uploadApi: this.$uploadApi,
      picture_params: {
        resourceName: 'literature',
        objectId: this.value?.id || 0
      },
      privateResourcesUrl: this.$privateResourcesUrl,
      remarksTags: [
        '报告体现生产单位；',
        '需要原始记录复印件；',
        '溶剂为；',
        '流动相为；',
        '℃-℃，℃/min，气氛；'
      ],
      sampleDisabled: true,
      remarks: '',
    }
  },
  watch: {
    value (val) {
      this.form =  JSON.parse(JSON.stringify(val))
      this.form.labExamItemIds = val.labExamItemList.map(e => e.id)
			this.form.isDisplayAll=val.isDisplayAll+''
    },
    form (val) {
      this.$emit('input', JSON.parse(JSON.stringify(val)))
    },
    'form.mandateStamped': {
      handler (val) {
       if (val) {
          if (this.form.remarks && this.form.remarks.indexOf('委托书盖章；') < 0) {
            this.$set(this.form, 'remarks', '委托书盖章；' + this.form.remarks);
          }
          if (!this.form.remarks) {
            this.$set(this.form, 'remarks', '委托书盖章；');
          }
        } else {
          if (this.form.remarks && this.form.remarks.indexOf('委托书盖章；') > -1) {
            this.$set(this.form, 'remarks', this.form.remarks.replace('委托书盖章；', ''));
          }
        }
      },
    },
    'form.showProductionOrg': {
      handler (val) {
        if (val) {
          if (this.form.remarks && this.form.remarks.indexOf('报告体现生产单位；') < 0) {
            this.$set(this.form, 'remarks', this.form.remarks + '报告体现生产单位；');
          }
          if (!this.form.remarks) {
            this.$set(this.form, 'remarks', '报告体现生产单位；');
          }
        } else {
          if (this.form.remarks && this.form.remarks.indexOf('报告体现生产单位；') > -1) {
            this.$set(this.form, 'remarks', this.form.remarks.replace('报告体现生产单位；', ''));
          }
        }
      },
    }
  },
  methods: {
    getdayType,
    addTagForRemark (tag) {
      if (!this.form.remarks) {
        this.$set(this.form, 'remarks', '');
      }
      if (this.form.remarks.indexOf(tag) === -1) {
        const newRemarks = this.form.remarks + tag;
        this.$set(this.form, 'remarks', newRemarks);
      }
    },
    getStatus (val) {
      this.$emit('isUpload', val)
    },
    cancel () {
      localStorage.removeItem('trustDeedForm')
      history.go(-1)
    },
    getAgentProduct (val) {
      let res = {}
      res.name = val.otherInfo.mallOrderName
      res.productCode = val?.product?.productCode
      return res
    },
    selectClient () {
      this.showClientDialog = true
    },
    closeClientDialog () {
      this.showClientDialog = false
    },
    closeDefaultDialog () {
      this.showDialog = false
    },
    selectProduct () {
      this.showDialog = true
    },
    closeDefaultDialog () {
      this.showDialog = false
    },
    getClient (val) {
      this.form.organization = val
      this.closeClientDialog()
    },
    selectData (val) {
      this.form.labExamItemList = val
      this.form.labExamItemIds = val.map(e => e.id)
      this.closeDefaultDialog()
    },
    deleteLabProduct (index) {
      this.form.labExamItemList.splice(index, 1)
    },
    formatToAjax () {
      let copyData = JSON.parse(JSON.stringify(this.form))

      if (copyData.attachments?.length && copyData.attachments.some(e => !e.response && !e.ossUrl)) {
        this.$message.warning('相关文献正在上传，请稍等...')
        return
      }

      copyData.reportNum = Number(copyData.reportNum)
      copyData.urgentMoney = Number(copyData.urgentMoney)
      copyData.examAmount = Number(copyData.examAmount)
      if (copyData.examBasisList && copyData.examBasisList.length) {
        copyData.examBasisList = copyData.examBasisList.map(e => e.value)
      }
			copyData.preOrderSummaryList = copyData.preOrderSummaryList.filter(e => e.disabled)
			copyData.attachments=[]
			copyData.isDisplayAll=(copyData.isDisplayAll==='true'||copyData.isDisplayAll==='false')?eval(copyData.isDisplayAll.toLowerCase()):copyData.isDisplayAll
      return copyData
    },
    createBill () {
      localStorage.removeItem('trustDeedForm')
      this.validate().then(form => {
        this.loading = true
        let copyData = this.formatToAjax()
        copyData.orderList = null

        // console.log('copyData=======================', copyData)
        // console.log('copyData===================w====', JSON.stringify(copyData))
        this.$store.dispatch('createBill', copyData).then(data => {
          this.$message.success('创建成功！')
          this.showSamples = true
          this.open = false
          this.sampleDisabled = false
          this.form.billCode = data.billCode
          this.form.id = data.id
        }).catch(errorMessage => {
          this.$message.error(errorMessage)
        }).finally(() => {
          this.loading = false
        })
      })
    },
    addSample () {
      const orderList = this.form.orderList.filter(e => e.disabled)
      if (!orderList?.length) {
        this.$message.warning('请先添加样品并保存')
        return
      }
      this.loading = true
      const otherParams = this.formatToAjax()
      const { id, billCode } = this.form
      const params = {
        orderList,
        billCode,
        id,
        ...otherParams
      }
      this.$store.dispatch('billImportOrder', params).then(data => {
        this.$message.success('创建成功！')
        this.$router.push('/trust-deed-list')
      }).catch(errorMessage => {
        this.$message.error(errorMessage)
      }).finally(() => {
        this.loading = false
      })
    },
    saveOrder () {
      localStorage.removeItem('trustDeedForm')
      this.validate().then(form => {
        const orderList = this.form.orderList
        if (!this.isEdit && !orderList?.length) {
          this.$message.warning('请先添加样品并保存')
          return
        }
        if (!this.$refs.sampleTable.disabled) {
          this.$message.warning('请先确认保存样品')
          return
        }
        this.loading = true
        const otherParams = this.formatToAjax()
        const { id, billCode } = this.form
        const params = {
          orderList,
          billCode,
          id,
          ...otherParams
        }
        const api = this.isEdit ? 'updateBill' : 'billImportOrder'
        this.$store.dispatch(api, params).then(data => {
          this.$message.success(this.isEdit ? '修改成功！' : '创建成功！')
          if (this.isEdit) {
            this.cancel()
          } else {
            this.$router.push('/trust-deed-list')
          }
        }).catch(errorMessage => {
          this.$message.error(errorMessage)
        }).finally(() => {
          this.loading = false
        })
      })
    },
    closeBill () {
      localStorage.removeItem('trustDeedForm')
      this.$confirm(`是否确认关闭该委托单？`, '确认关闭委托单', {
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      }).then(() => {
        this.loading = true
        this.$store.dispatch('closeBill', this.form.id).then(res => {
          this.$message.success('操作成功')
          this.$router.push('/trust-deed-list')
        }).catch(err => {
          this.$message.warning(err || '操作失败')
        }).finally(() => {
          this.loading = false
        })
      })
    },
    deleteBill () {
      localStorage.removeItem('trustDeedForm')
      this.$confirm(`是否确认删除该委托单，删除后将不可恢复！`, '确认删除委托单', {
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      }).then(() => {
        this.loading = true
        this.$store.dispatch('deleteBill', this.form.id).then(res => {
          this.$message.success('操作成功')
          this.$router.push('/trust-deed-list')
        }).catch(err => {
          this.$message.warning(err || '操作失败')
        }).finally(() => {
          this.loading = false
        })
      })
    },
    goBack () {
      localStorage.removeItem('trustDeedForm')
    }
  },
  created () { 
    this.$router.beforeEach((to, from, next) => {
      if (to.name === 'lab-product-detail') {
        localStorage.setItem('trustDeedForm', JSON.stringify(this.form))
      }
      next()
    })
    let trustDeedForm = localStorage.getItem('trustDeedForm')
    this.form = trustDeedForm ? JSON.parse(trustDeedForm) : this.form
    this.$set(this, 'form', trustDeedForm ? JSON.parse(trustDeedForm) : this.form)
  },
  mounted () {
    window.addEventListener('popstate', (event) => {
      if (this.$route.name !== 'trust-deed-form') {
        this.goBack()
      }
    });
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-lab-order-form {
  :global {	
    .el-tag {
    margin-right: 10px;
  }
    .wt-upload-file {
      line-height: 0;
			margin-top: 0;
			.el-upload-list__item:first-child{
			margin-top: 0;
			}
    }
    .el-input,
    .el-input__inner {
      max-width: 2.8rem;
    }
    .el-input--suffix .el-input__inner {
      min-width: 2.8rem;
    }
    .el-upload--picture-card,
    .el-upload-list--picture-card .el-upload-list__item {
      width: 117px;
      height: 155px;
    }
    el-textarea,
    .el-textarea__inner {
      width: 500px;
      font-family: "Microsoft YaHei", "微软雅黑", "Avenir", Helvetica, Arial;
    }
    .wt-upload-file {
      line-height: 0;
      margin-top: 10px;
    }
  }
  .age {
    :global {
      .el-input--suffix .el-input__inner {
        min-width: 1.5rem;
      }
    }
  }
  .address {
    :global {
      .el-select .el-input,
      .el-input__inner {
        height: 0.4rem !important;
      }
    }
  }
  .upload-file-text {
    line-height: 155px;
  }
  .dashed {
    margin: 30px 0;
    height: 1px;
    background-image: linear-gradient(
      to right,
      #ccc 0%,
      #ccc 50%,
      transparent 50%
    );
    background-size: 8px 1px;
    background-repeat: repeat-x;
  }
  .package-table-div {
    margin-top: 10px;
    padding: 10px 20px 30px;
    max-width: 800px;
  }
  .package-table {
    display: table !important;
    width: 100%;
    border-collapse: collapse !important;
    th,
    tr {
      width: 100% !important;
      max-width: 100% !important;
      display: table-row;
      padding: 0 !important;
      list-style-type: none;
      border-bottom: 1px solid #c6c9d3;
      color: #818181;
    }
    td {
      text-align: center;
      line-height: 30px;
    }
  }
}
</style>
